import React, { ReactElement } from "react";
import { AuthProvider } from "./Auth";
import { ToastProvider } from "./Toast";

export const AppProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <AuthProvider>
      <ToastProvider>
        <>{children}</>
      </ToastProvider>
    </AuthProvider>
  );
};
